<div class="select-container">
  <select [(ngModel)]="selectedOption" (ngModelChange)="onChange($event)">
    <option value="allTime">All Time</option>
    <option value="7">Last 7 Days</option>
    <option value="30">Last 30 Days</option>
    <option value="90">Last 90 Days</option>
    <option value="dateToNow">Date to Now</option>
    <option value="dateRange">Custom Range</option>
    <option value="aux" class="auxiliar-option">{{ auxiliarText }}</option>
  </select>
  <div class="icon-container">
    <div class="icon-down_small"></div>
  </div>
</div>
<!-- This form only exist for 2 things:
     1. Hold datepicker and daterange from material. They must be included this way
     2. The mat-form-field acts as a anchor reference for the caledar to be displayed. This is
        the way Material UI references where to show the caledar. So its position will
        govern where the calendar will show
    This form is 'hidden' by using 0 width and height.
-->
<mat-form-field class="mat-form-field">
  <input
    matInput
    [matDatepicker]="singleDatePicker"
    [max]="today"
    (dateChange)="onSingleDatePickerDateChange($event)"
  />
  <mat-datepicker #singleDatePicker (closed)="onCalendarClose()"></mat-datepicker>

  <mat-date-range-input [rangePicker]="dateRangePicker" [max]="today">
    <input matStartDate (dateChange)="onStartDateChange($event)" />
    <input matEndDate (dateChange)="onEndDateChange($event)" />
  </mat-date-range-input>
  <mat-date-range-picker #dateRangePicker (closed)="onCalendarClose()"></mat-date-range-picker>
</mat-form-field>
